function Roller() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="2" width="20" height="8" rx="2" />
      <path d="M6 10v4a2 2 0 0 0 2 2h8a2 2 0 0 1 2 2v4" />
    </svg>
  );
}

export default Roller;
